import { render, staticRenderFns } from "./CompFavoritesOptionItem.vue?vue&type=template&id=7ff3e038"
import script from "./CompFavoritesOptionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CompFavoritesOptionItem.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports